import { Component, Input, OnChanges } from '@angular/core';
import { ConfigurationService } from '../services/configuration.service';

@Component({
  selector: 'app-barcode-display',
  templateUrl: './barcode-display.component.html',
  styleUrls: ['./barcode-display.component.scss'],
  standalone: false,
})
export class BarcodeDisplayComponent implements OnChanges {
  @Input() barcodeData!: string;
  public barcodeID: string = 'barcode';

  constructor(public configService: ConfigurationService) {}

  ngOnChanges(): void {
    this.barcodeID = this.barcodeData;
  }

  ngOnInit(): void {}
}
